import useQueryWithAuth from 'src/hooks/useQueryWithAuth';

import { MoreSettingsResponse } from './types';

enum APIList {
  /**
   * 더보기 설정에서 표시되는 설정 목록을 조회하는 API
   * @see https://www.notion.so/hpcnt/Azar-Cheero-Vividi-Liquidity-Sharing-1d7ce00cd35480649832c7854968b836?pvs=4#1e4ce00cd35480799d27df4a7b6ff64a
   */
  MoreSettings = '/api/more-settings/more',
}

export const MORE_SETTINGS_QUERY_KEYS = {
  moreSettings: () => [APIList.MoreSettings],
};

export const useGetMoreSettingsQuery = () => {
  return useQueryWithAuth<void, MoreSettingsResponse, void>({
    path: APIList.MoreSettings,
    queryKey: MORE_SETTINGS_QUERY_KEYS.moreSettings(),
    options: {
      staleTime: Infinity,
      gcTime: Infinity,
    },
  });
};
